<template>
  <span :class="classes" @mouseenter="expand = true" @mouseleave="mode === 'hidden' ? expand = false: null">
    <router-link
      :class="!expand && 'fas fa-sign-out-alt'"
      class="indicate-text "
      :to="to"
    >
      {{ expand ? label : ''}}
    </router-link>
  </span>
</template>

<script>
export default {
  props: {
    classes: {type: String},
    mode: { type: String },
    to: { type: String },
    label: { type: String },
  },
  data() {
    return {
      expand: this.mode !== 'hidden',
    };
  },
};

/** Example component usage:
 * 
 * <ilink mode="hidden" to="/" label="home">
 * <ilink mode="hidden" list="google.com" label="home">
 */
</script>